import { Box, HStack, VStack, Text, Badge, IconButton } from '@chakra-ui/react';
import { FiEdit2 } from 'react-icons/fi'
import type { SurveyGroupSummaryDto } from '../../types/survey'

interface SurveyGroupCardProps {
  group: SurveyGroupSummaryDto
  onEditGroup: (group: SurveyGroupSummaryDto) => void
  onEditQuestion: (questionId: string) => void
}

export function SurveyGroupCard({ group, onEditGroup }: SurveyGroupCardProps) {
  return (
    <Box bg="surface" borderRadius="lg" shadow="md" overflow="hidden">
      <HStack
        p={4}
        justify="space-between"
        _hover={{ bg: 'gray.50' }}
      >
        <HStack gap={4} flex={1}>
          <VStack align="start" gap={0}>
            <Text fontWeight="bold">{group.label}</Text>
            {group.description && (
              <Text fontSize="sm" color="gray.600">
                {group.description}
              </Text>
            )}
          </VStack>
          <Badge bg="info.subtle" color="info.fg" fontSize="xs">
            {group.questionCount} {group.questionCount === 1 ? 'question' : 'questions'}
          </Badge>
        </HStack>
        <IconButton
          aria-label="Edit group"
          size="sm"
          variant="ghost"
          onClick={(e) => {
            e.stopPropagation()
            onEditGroup(group)
          }}><FiEdit2 /></IconButton>
      </HStack>
    </Box>
  );
}
